import { ROUTES, SUB_PAGE_MAP } from '../constants/routes'

export const getSearchLink = (contentType, slug, parentCategory) => {
  switch (contentType) {
    case 'product':
      return `${ROUTES.PRODUCTS}/${slug}`
    case 'pageBlogArticle':
    case 'pageSupportGuide':
      return `${ROUTES.BLOG}/posts/${slug}`
    case 'pageHomapage':
      return '/'
    case 'pageSubLevelTemplate':
      return `${parentCategory || parentCategory !== 'None' ? `${SUB_PAGE_MAP[parentCategory]}` : ''}/${slug}`
    case 'pageCollections':
      return `${ROUTES.COLLECTIONS}/${slug}`
    case 'pageTrainingTopLevel':
      return ROUTES.TRAINING_TOP_LEVEL
    case 'pageProductFamily':
      return `${ROUTES.DRONES}/${slug}`
    case 'pageSurveyTopLevel':
      return ROUTES.SURVEY_TOP_LEVEL
    case 'pageRichSubPage':
      return `${parentCategory || parentCategory !== 'None' ? `${SUB_PAGE_MAP[parentCategory]}` : ''}/${slug}`
    case 'pageBasicPage':
      return `${ROUTES.SUPPORT}/${slug}`
    case 'pageGsdCalculator':
      return `/${slug}`
    case 'pageIndustry':
      return ROUTES.INDUSTRY_TOP_LEVEL
    case 'pageIndustrySubLevel':
      return `${ROUTES.INDUSTRY_TOP_LEVEL}/${slug}`
    case 'pageTrainingCalculator':
      return `/${slug}`
    case 'pageJob':
      return `${ROUTES.CAREERS}/${slug}`
    case 'pageRepairCalculator':
      return `/${slug}`
    case 'pageTermsAndConditions':
      return `${ROUTES.SUPPORT}/${slug}`
    default:
      return '/'
  }
}
